// extracted by mini-css-extract-plugin
module.exports = {"container":"Banner_container__174je","subtitle":"Banner_subtitle__Dp4rx"};